import { AppExtensionConfig, AppExtensionFactory } from '../Extension';
import { SlackAppExtension } from './SlackAppExtension';

export class SlackAppExtensionFactory implements AppExtensionFactory<SlackAppExtension> {
  create(config: AppExtensionConfig): SlackAppExtension {
    return config;
  }
}
